// context/ArticlesProvider.js
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import authHeader from "../../Auth/authHeader";
import { errorAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";

export const ArticlesContext = createContext();

export const ArticlesProvider = ({ children }) => {
    const [articles, setArticles] = useState([]);
    const headers = authHeader();


    const fetchArticles = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Article', { headers });
            setArticles(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        fetchArticles();
    }, []);


    return (
        <ArticlesContext.Provider value={{ articles, fetchArticles }}>
            {children}
        </ArticlesContext.Provider>
    );
};
